/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { QueueItemStatus } from '../models/QueueItemStatus';
import type { SchedulerActionConfig } from '../models/SchedulerActionConfig';
import type { SchedulerActionConfigDto } from '../models/SchedulerActionConfigDto';
import type { SchedulerActionLog } from '../models/SchedulerActionLog';
import type { SchedulerOrgConfig } from '../models/SchedulerOrgConfig';
import type { SchedulerQueue } from '../models/SchedulerQueue';
import type { SchedulerQueueDto } from '../models/SchedulerQueueDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SchedulerAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param sysOrgGuid
     * @param statuses
     * @returns SchedulerQueue OK
     * @throws ApiError
     */
    public getApiSchedulerAdminGetAllScheduledItems(
        sysOrgGuid?: string,
        statuses?: Array<QueueItemStatus>,
    ): CancelablePromise<Array<SchedulerQueue>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SchedulerAdmin/GetAllScheduledItems',
            query: {
                'sysOrgGuid': sysOrgGuid,
                'statuses': statuses,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param scheduledItemId
     * @returns SchedulerQueue OK
     * @throws ApiError
     */
    public getApiSchedulerAdmin(
        scheduledItemId: number,
    ): CancelablePromise<SchedulerQueue> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SchedulerAdmin/{scheduledItemId}',
            path: {
                'scheduledItemId': scheduledItemId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param scheduledItemId
     * @param requestBody
     * @returns number OK
     * @throws ApiError
     */
    public putApiSchedulerAdmin(
        scheduledItemId: number,
        requestBody?: SchedulerQueueDto,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/SchedulerAdmin/{scheduledItemId}',
            path: {
                'scheduledItemId': scheduledItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param scheduledItemId
     * @returns any OK
     * @throws ApiError
     */
    public deleteApiSchedulerAdmin(
        scheduledItemId: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/SchedulerAdmin/{scheduledItemId}',
            path: {
                'scheduledItemId': scheduledItemId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns number OK
     * @throws ApiError
     */
    public postApiSchedulerAdminCreateScheduledItem(
        requestBody?: SchedulerQueueDto,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SchedulerAdmin/CreateScheduledItem',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param scheduledItemId
     * @returns SchedulerQueue OK
     * @throws ApiError
     */
    public postApiSchedulerAdminTriggerScheduledItem(
        scheduledItemId: number,
    ): CancelablePromise<SchedulerQueue> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SchedulerAdmin/{scheduledItemId}/TriggerScheduledItem',
            path: {
                'scheduledItemId': scheduledItemId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @returns any OK
     * @throws ApiError
     */
    public postApiSchedulerAdminRetryFailedScheduledItems(
        sysOrgGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SchedulerAdmin/{sysOrgGuid}/RetryFailedScheduledItems',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SchedulerOrgConfig OK
     * @throws ApiError
     */
    public getApiSchedulerAdminGetOrgConfigs(): CancelablePromise<Array<SchedulerOrgConfig>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SchedulerAdmin/GetOrgConfigs',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @param requestBody
     * @returns SchedulerOrgConfig OK
     * @throws ApiError
     */
    public putApiSchedulerAdminOrgConfig(
        sysOrgGuid: string,
        requestBody?: SchedulerOrgConfig,
    ): CancelablePromise<SchedulerOrgConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/SchedulerAdmin/org-config/{sysOrgGuid}',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SchedulerActionConfig OK
     * @throws ApiError
     */
    public getApiSchedulerAdminGetActionConfigs(): CancelablePromise<Array<SchedulerActionConfig>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SchedulerAdmin/GetActionConfigs',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns SchedulerActionConfig OK
     * @throws ApiError
     */
    public putApiSchedulerAdminActionConfig(
        id: number,
        requestBody?: SchedulerActionConfigDto,
    ): CancelablePromise<SchedulerActionConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/SchedulerAdmin/action-config/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param levels
     * @returns SchedulerActionLog OK
     * @throws ApiError
     */
    public getApiSchedulerAdminGetSchedulerLogs(
        levels?: Array<string>,
    ): CancelablePromise<Array<SchedulerActionLog>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SchedulerAdmin/GetSchedulerLogs',
            query: {
                'levels': levels,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
